import { styled } from '@mui/material';
import { Query } from '../../../components/Query';
import { api } from '../../../lib/api';
import { FicheRenseignementTable } from './FicheRenseignementTable';

function FicheRenseignementEntries() {
    return (
        <Query
            queryKey={['fiche-renseignement-entries']}
            apiCall={api.getFicheRenseignementEntries}
        >
            {(data) => (
                <TableContainer>
                    <FicheRenseignementTable ficheRenseignementEntries={data} />
                </TableContainer>
            )}
        </Query>
    );
}

const TableContainer = styled('div')(({ theme }) => ({
    width: '100%',
}));

export { FicheRenseignementEntries };
